<template>
  <div :class="['relative flex items-center justify-center', className]">
    <i-mdi-share
      v-if="shared"
      :class="[
        'absolute -right-0.5 -top-1 h-4 w-4 stroke-white stroke-1',
        arrowColor,
      ]"
    ></i-mdi-share>
    <ClipboardIcon
      :class="className"
      :focus
      :colorClass="colorClass || 'text-schema-own'"
      :filled
    />
  </div>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    shared?: boolean;
    focus?: boolean;
    className?: string;
    colorClass?: string;
    arrowColor?: string;
    filled?: boolean;
  }>(),
  {
    shared: false,
    focus: false,
    filled: false,
    className: "size-4",
    arrowColor: "text-entry-green-darker",
    colorClass: undefined,
  }
);
</script>
